// Vendor Libs
import React from 'react';

// Components
import Permissions from '../core/permissions';
import RulesForm from './rules-form';

// Containers
import FormData from '../../containers/form-data';

const formName = 'createRule';

const CreateRule = () => (
    <Permissions adminOnly={true} hidePanel={true}>
        <FormData formName={formName}>
            {({resetForm}) => (
                <RulesForm
                    {...{
                        className: 'create-rule',
                        editing: false,
                        name: formName,
                        onReset: resetForm,
                    }}
                />
            )}
        </FormData>
    </Permissions>
);

export default CreateRule;
